// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/anagrafiche/insegne?societaId=N&includiDisattivate=1',
    requestBody: null,
    response: '[{"id":3,"societaId":1,"societa":{"id":1,"nome":"Smartix"},"codice":"BRICO","nome":"Bricocenter","note":null,"attivo":true,"_count":{"codiciArticolo":40,"clienti":2}}]'
  },
  {
    method: 'DELETE',
    endpoint: '/api/anagrafiche/insegne/:id',
    requestBody: null,
    response: '{"message":"Insegna disattivata"}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/insegne/:id/riattiva',
    requestBody: null,
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/anagrafiche/insegne',
    requestBody: '{"societaId":1,"codice":"BRICO","nome":"Bricocenter","note":null}',
    response: '{"id":3,"societaId":1,"codice":"BRICO","nome":"Bricocenter","note":null,"attivo":true}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
